
import { defineComponent } from 'vue'
import { computed } from '@vue/reactivity'
export default defineComponent({
  props: {
    total: {
      required: true,
      type: Number,
    },
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 15,
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100]
      },
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },
    background: {
      type: Boolean,
      default: true,
    },
    autoScroll: {
      type: Boolean,
      default: true,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: any, ctx) {
    const currentPage = computed({
      get() {
        return props.page
      },
      set(val) {
        ctx.emit('update:page', val)
      },
    })
    const pageSize = computed({
      get() {
        return props.limit
      },
      set(val) {
        ctx.emit('update:limit', val)
      },
    })

    const handleSizeChange = (val: any) => {
      ctx.emit('pagination')
    }
    const handleCurrentChange = (val: any) => {
      ctx.emit('pagination')
    }
    return { currentPage, pageSize, handleSizeChange, handleCurrentChange }
  },
})
